import { constant, get, getOr, map, filter, flow, union } from 'lodash/fp';
import { addConfigurationsToCart } from '../../../api/thd';
import config from '../../../helpers/config';

export default (cartingOptions) => {
  const job = get('job', cartingOptions);

  const productOnlyConfigurations = flow(
    get('productOnlyItems'),
    map(item => ({
      configurationId: get('itemProduct.configurationGuid', item),
      skuNumber: get('itemProduct.skuNumber', item),
    })),
  )(cartingOptions);

  const productConfigurations = flow(
    get('items'),
    filter({ type: 'window' }),
    filter('productInformation.configurationId'),
    filter('productInformation.skuId'),
    map('productInformation'),
    map(({ configurationId, skuId }) => ({
      configurationId,
      skuNumber: skuId,
    })),
    union(productOnlyConfigurations),
  )(job);

  const configs = [
    {
      configurationId: get('id', job),
      skuNumber: config.wellKnownProductIds.mandi[get('serviceType', job)],
    },
    ...getOr(false, 'options.cartProducts', cartingOptions) ? productConfigurations : [],
  ];

  return addConfigurationsToCart(configs)
    .then(constant(cartingOptions));
};
